<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="130px">
      <el-form-item
        label="培训名称："
        prop="videoName">
        <el-input v-model="info.videoName"></el-input>
      </el-form-item>
      <el-form-item
        label="类型："
        prop="groupId">
        {{ info.trainingType | trainingTypeName() }}
      </el-form-item>
      <el-form-item
        label="培训内容："
        prop="trainingContent">
        <el-input
          v-model="info.trainingContent"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
      <template v-if="info.trainingType === 1">
        <el-form-item
          label="培训视频封面："
          prop="videoImage">
          <upload-with-crop
            v-model="info.videoImage"
            cropper
            :isLt2M="500"
            :fixedNumber="[8,5]"
            :autoCropWidth="320"
            :autoCropHeight="200"></upload-with-crop>
        </el-form-item>
        <el-form-item
          label="培训视频链接："
          prop="videoPlayUrl">
          <el-input
            v-model="info.videoPlayUrl"
            type="textarea"
            :rows="4"
            :autosize="{ minRows: 2, maxRows: 4}"></el-input>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        {{ submitText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
export default {
  name: 'EditVideoModal',
  components: { UploadWithCrop },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        trainingVideoId: null,
        trainingType: 1,
        trainingContent: null,
        videoName: '',
        videoImage: [],
        videoPlayUrl: ''
      },
      rules: {
        // groupId: [
        //   { required: true, message: '请选择视频分组', trigger: 'change' }
        // ],
        videoName: [
          { required: true, message: '请输入培训名称', trigger: 'blur' },
          { max: 30, message: '培训名称长度最多 30 个字符', trigger: 'blur' }
        ],
        videoImage: [
          { required: true, message: '请上传培训视频封面', trigger: 'change' }
        ],
        trainingContent: [
          { required: true, message: '请输入培训内容', trigger: 'blur' },
          { max: 50, message: '培训名称长度最多 50 个字符', trigger: 'blur' }
        ],
        videoPlayUrl: [
          { required: true, message: '请输入培训视频链接', trigger: 'blur' },
          { type: 'url', message: '请输入正确的培训视频链接', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const trainingVideoId = this.info.trainingVideoId
      return (trainingVideoId ? '编辑' : '新增') + '培训内容'
    },
    submitText() {
      const trainingVideoId = this.info.trainingVideoId
      return trainingVideoId ? '更新' : '保存'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        trainingVideoId: null,
        // groupId: null,
        videoName: '',
        videoImage: [],
        videoPlayUrl: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.trainingVideoId
            ? 'updatetrainingvideo'
            : 'addtrainingvideo'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              videoImage: this.info.videoImage.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(trainingType) {
      this.info.trainingType = trainingType
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
